export const TABLE_LAST_USED_PURPOSE_CODES = 'routableLastUsedPurposeCodes';
